export const ASSETS_BASE = "https://assets.certificadoradigital.com";

export const ASSETS = {
  logo: `${ASSETS_BASE}/assets/logo.svg`,
  favicon: `${ASSETS_BASE}/assets/ico-biz.svg`,
  // Kept for <link rel="icon" type="image/png"> and apple-touch-icon fallbacks.
  faviconPng: `${ASSETS_BASE}/brand/favicon.v3.png`,
  icon512: `${ASSETS_BASE}/brand/icon-512.v3.png`,
  govbr: `${ASSETS_BASE}/brand/Govbr.svg`,
  iti: `${ASSETS_BASE}/brand/ITI.svg`,
  soluxId: `${ASSETS_BASE}/brand/SoluxID.svg`,
  placeholder: `${ASSETS_BASE}/brand/placeholder.svg`,
  heroWork: `${ASSETS_BASE}/hero/hero-work.jpg`,
  slide1: `${ASSETS_BASE}/hero/slide-1-person.jpg`,
  slide2: `${ASSETS_BASE}/hero/slide-2-person.jpg`,
  slide3: `${ASSETS_BASE}/hero/slide-3-person.jpg`,
  assinaturasHero: `${ASSETS_BASE}/hero/assinaturas-hero.jpg`,
  certificateInfoPerson: `${ASSETS_BASE}/hero/certificate-info-person.jpg`,
} as const;

export const productImage = (filename: string) => `${ASSETS_BASE}/products/${filename}`;
